import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from '@/store/store'
import Spinner from 'vue-simple-spinner'
import notie from '@/notieFocusSafe'
import axios from 'axios'
import tabs from '@/components/Tabs.vue'
import tab from '@/components/Tab.vue'
import formGenerator from '@/components/FormGenerator.vue'
import ShowmanTable from '@/components/ShowmanTable.vue'
import DropdownButton from '@/components/DropdownButton.vue'
import DatePicker from 'vue2-datepicker'
import ShareButton from '@/components/ShareButton.vue'
import {BModal} from 'bootstrap-vue'

import Multiselect from 'vue-multiselect'
import VueFormGenerator from 'vue-form-generator'
import VTooltip from 'v-tooltip'
import VueMask from 'v-mask'

import '@/assets/css/tailwind.css'
import '@/assets/css/transistions.css'
import '@/assets/css/bootstrap-modal.css'
import '@/assets/css/tooltip.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import 'vue-select/dist/vue-select.css'
import 'vue2-datepicker/index.css'

import vSelect from 'vue-select'
import DisplayFileTypeField from '@/components/DisplayFileTypeField.vue'

import * as Fathom from 'fathom-client'
import * as Localized from './localizationConfig'
import * as UserAccess from './userAccessLevel'
import {can} from '@/access/accessControl'
import {prepareEntryGroup} from '@/utils/entryGrouping'

// Upon initial page load...
Fathom.load('WWZHYRHZ')

/* const config = {
  apiKey: '50ea79d3',
  environment: process.env.NODE_ENV,
  revision: process.env.VUE_APP_GIT_VERSION
} */

Vue.config.productionTip = false

Vue.component('date-picker', DatePicker)

Vue.component('vue-simple-spinner', Spinner)
Vue.component('tab', tab)
Vue.component('tabs', tabs)
Vue.component('form-generator', formGenerator)
Vue.component('showman-table', ShowmanTable)
Vue.component('dropdown-button', DropdownButton)
Vue.component('share-button', ShareButton)
Vue.component('multiselect', Multiselect)
Vue.use(VueFormGenerator)
Vue.use(VueMask)
Vue.use(VTooltip, {
  defaultHideOnTargetClick: true
})
Vue.component('v-select', vSelect)
Vue.component('display-file-type-field', DisplayFileTypeField)

Vue.component('b-modal', BModal)

Vue.prototype.axios = axios
Vue.prototype.Fathom = Fathom
Vue.prototype.notie = notie
Vue.prototype.formatGrade = (grade) => {
  if (grade === 1) {
    return '1st'
  } else if (grade === 2) {
    return '2nd'
  } else if (grade === 3) {
    return '3rd'
  } else {
    return `${grade}th`
  }
}
// linkify()'s result is rendered with v-html, so its input must be HTML-escaped.
function escapeHtml (value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}
Vue.prototype.escapeHtml = escapeHtml
Vue.prototype.linkify = function linkify (text) {
  if (text === null || text === undefined) return ''
  // Escape before matching URLs, not after: the regex runs on the escaped
  // string so an & in a query string is already &amp; and survives in the href.
  var exp = /(\b(https?):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
  return escapeHtml(text).replace(exp, '<a class="link break-all" href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
}

// Quick Fix
Vue.prototype.filterRingDivisions = function (showBook, ringID, ringSettings) {
  if (ringSettings) {
    if (ringSettings.length > 1) {
      let ring = null
      if (ringID === 'Overall') {
        showBook.forEach(c => {
          if (c.division !== 'Overall') {
            c.hide = true
          } else {
            c.hide = false
          }
        })
      } else {
        if (ringID) {
          if (ringID !== 'All Rings') {
            ringSettings.forEach(r => {
              if (r.name === ringID) {
                ring = r
              }
            })
          }
        } else {
          ring = ringSettings[0]
        }
        if (ring) {
          if (ring.divisions) {
            if (ring.divisions.length) {
              showBook.forEach(c => {
                if (!ring.divisions.includes(c.division)) {
                  c.hide = true
                } else {
                  c.hide = false
                }
              })
            }
          }
        }
      }
    }
  }
  return showBook
}

// Splits cards that hold the same show twice into one card per entry, and keeps a copy of each
// card's loaded entry_details so saves only write what the user changed (see utils/entryGrouping).
Vue.prototype.fixEntryGrouping = prepareEntryGroup
Vue.prototype.Localized = Localized.default
Vue.prototype.UserAccess = UserAccess.default
// Capability check available as this.$can('capability') in every component
// (same definition as pages/internal/main.js). UX gating only — the backend
// enforces every capability separately.
// The site's own URL — VUE_APP_ROOT_URL: https://showman.app in production, localhost:8080
// on a laptop, the published port in a containerized worktree (set by its compose file).
// Every link the app builds to itself goes through this instead of a hardcoded domain.
Vue.prototype.$rootUrl = process.env.VUE_APP_ROOT_URL

Vue.prototype.$can = function (capability) {
  return can(this.$store.getters.getUserID, capability)
}

Vue.prototype.getParameterByName = function getParameterByName (name, url) {
  if (!url) url = window.location.href
  name = name.replace(/[[\]]/g, '\\$&')
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
  var results = regex.exec(url)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
